
// TODO: see about using some nameof() package here. maybe?
export const authTypes = {
  state: {
    isAuthenticated: 'isAuthenticated',
    user: 'user',
    appConfigSettings: 'appConfigSettings',
    appConfigLoaded: 'appConfigLoaded',
    appUser: 'appUser'
  },
  mutations: {
    updateAuthState: 'updateAuthStatus',
    updateUserInfo: 'updateUserInfo',
    updateAppSettings: 'updateAppSettings'
  },
  actions: {
    setAuth: 'setAuth',
    setAppSettings: 'setAppSettings',
  }
};
